import { Component, Input, OnInit } from '@angular/core';
import { WizardOption } from 'src/app/models/wizard/wizard-option';
import { ConfigService } from 'src/app/services/config/config.service';
import { WizardStepName } from 'src/app/services/wizard/wizard-step-name.enum';
import { WizardService } from 'src/app/services/wizard/wizard.service';

@Component({
  selector: 'app-selections',
  templateUrl: './selections.component.html',
  styleUrls: ['./selections.component.scss']
})
export class SelectionsComponent implements OnInit {
  @Input()
  showTitle: boolean = true;
  title: string = "";
  primaryUseLabel: string = "";
  primaryUse: string = "";
  needToRunLabel: string = "";
  needToRun: string = "";
  useCaseLabel: string = "";
  useCase: string = "";
  brandsLabel: string = "";
  brands: string = "";

  constructor(private wizardService: WizardService, private confSvc: ConfigService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.title = this.confSvc.getString("selectionsTitle");
    this.primaryUseLabel = this.confSvc.getString("selectedIndustryLabel");
    this.needToRunLabel = this.confSvc.getString("selectedActivitiesLabel");
    this.useCaseLabel = this.confSvc.getString("selectedWorkerLabel");
    this.brandsLabel = this.confSvc.getString("selectedBrandLabel");

    this.setTextForSelections();
  }

  setTextForSelections(): void {
    this.wizardService.getSelectedWizardOptionsForStepAndWatch(WizardStepName.PrimaryUse)
    .subscribe((options) => {
      this.primaryUse = this.getFormattedText(options);
    });

    this.wizardService.getSelectedWizardOptionsForStepAndWatch(WizardStepName.NeedToRun)
    .subscribe(options => {
      this.needToRun = this.getFormattedText(options);
    });

    this.wizardService.getSelectedWizardOptionsForStepAndWatch(WizardStepName.UseCase)
    .subscribe(options => {
      this.useCase = this.getFormattedText(options);
    });

    this.wizardService.getSelectedWizardOptionsForStepAndWatch(WizardStepName.Brands)
    .subscribe(options => {
      this.brands = this.getFormattedText(options);
    });
  }

  getFormattedText(options: WizardOption[]): string {
    return options.map(option => option.title).join(', ');
  }
}
